var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "w-100"
  }, [_vm.error && _vm.error.key ? _c('b-alert', {
    staticClass: "mt-4",
    attrs: {
      "show": "",
      "variant": "danger"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(_vm.error.key, Object.assign({}, _vm.error.validationMessages, {
    package: _vm.$t(`package.type.${_vm.error.validationMessages.package}`)
  }))) + " ")]) : _vm._e(), _c('b-form', {
    staticClass: "w-100",
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.onSubmit.apply(null, arguments);
      }
    }
  }, [_c('form-input', {
    attrs: {
      "id": "sheet-name",
      "label": _vm.$t('sheet.popup.form.name'),
      "state": _vm.getState('name'),
      "required": "",
      "type": "text"
    },
    scopedSlots: _vm._u([{
      key: "validation-messages",
      fn: function () {
        return [!_vm.$v.formData.name.maxLength ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.max-length', {
          field: _vm.$t('sheet.popup.form.name'),
          max: _vm.$v.formData.name.$params.maxLength.max
        })) + " ")]) : _vm._e(), !_vm.$v.formData.name.required ? _c('b-form-invalid-feedback', [_vm._v(" " + _vm._s(_vm.$t('validation.required', {
          field: _vm.$t('sheet.popup.form.name')
        })) + " ")]) : _vm._e()];
      },
      proxy: true
    }]),
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", typeof $$v === 'string' ? $$v.trim() : $$v);
      },
      expression: "formData.name"
    }
  }), _c('div', {
    staticClass: "mt-4"
  }, [_c('b-button', {
    staticClass: "w-100",
    attrs: {
      "type": "submit",
      "variant": "primary"
    }
  }, [_vm._v(" " + _vm._s(_vm.$t(`sheet.popup.form.button.submit`)) + " ")])], 1)], 1)], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }